(() => {
  'use strict';
  if (window.beaconMetricoolInitialized) return;
  window.beaconMetricoolInitialized = true;
  let sent = false;

  function trackWhenAllowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (sent || !privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    try {
      if (privacy.analyticsProcessingAllowed() !== true) return;
    } catch (_) {
      return;
    }
    const pixel = document.createElement('img');
    pixel.alt = '';
    pixel.width = 1;
    pixel.height = 1;
    pixel.setAttribute('aria-hidden', 'true');
    pixel.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;pointer-events:none;';
    sent = true;
    pixel.src = 'https://tracker.metricool.com/c3po.jpg?hash=8184ddefb7881622d8a9383224c0a6c9';
    document.body.appendChild(pixel);
  }

  document.addEventListener('visitorConsentCollected', trackWhenAllowed);
  const shopify = window.Shopify;
  if (shopify && shopify.customerPrivacy) {
    trackWhenAllowed();
  } else if (shopify && typeof shopify.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      if (!error) trackWhenAllowed();
    });
  }
})();
